import * as React from "react"
import Svg, { G, Path, Defs } from "react-native-svg"
/* SVGR has dropped some elements not supported by react-native-svg: filter */

function SuccessIcon(props) {
  return (
    <Svg
      width={202}
      height={202}
      viewBox="0 0 202 202"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G filter="url(#filter0_di_712_3440)">
        <Path
          d="M16.8 91.2c0-46.392 37.608-84 84-84s84 37.608 84 84-37.608 84-84 84-84-37.608-84-84z"
          fill="#E2F2E8"
          shapeRendering="crispEdges"
        />
        <G filter="url(#filter1_dii_712_3440)">
          <Path
            d="M43.2 91.2c0-31.812 25.789-57.6 57.6-57.6 31.812 0 57.6 25.788 57.6 57.6s-25.788 57.6-57.6 57.6c-31.811 0-57.6-25.788-57.6-57.6z"
            fill="#38B24A"
            shapeRendering="crispEdges"
          />
          <Path
            d="M85.2 92.4l12 12 19.2-21.6"
            stroke="#fff"
            strokeWidth={4.2}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </G>
      </G>
      <Defs></Defs>
    </Svg>
  )
}

export default SuccessIcon
